import { withStyles } from '@material-ui/core/styles';
import Drawer from './Drawer';
import styles from './Drawer.styles';
import reducer from './reducer';

const StyledDrawer = withStyles(styles)(Drawer);
/**
 * Note: By default HOC doesn't pass static methods to new Component
 * @see https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
 */
export default Object.assign(StyledDrawer, { reducer });
